import Color from '../Color/Color'
import InvisiButton from '../InvisiButton/InvisiButton'
import Paragraph from '../Paragraph/Paragraph'
import Tooltip from '../Tooltip/Tooltip'
import classes from './ParameterChip.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  label: ReactNode
  children: ReactNode
  onClick?: () => void
  isDisabled?: boolean
  key?: string
  backgroundVariance?: 'white' | 'transparent' | 'theme-grey'
  hasTooltip?: boolean
}

const ParameterChip = ({
  label,
  children,
  onClick,
  isDisabled = false,
  key = '',
  backgroundVariance = 'transparent',
  hasTooltip = true
}: Props) => {
  const getParameterChipClass = () => [
    classes.ParameterChip,
    classes[backgroundVariance]
  ].filter(classStyle => classStyle).join(' ')

  const renderContent = () => (
    <div
      aria-label='ParameterChip'
      className={getParameterChipClass()}
    >
      <Paragraph variant='text-overflow'>
        <small>
          <Color
            display='inline'
            variant='theme-description-text'
          >
            {children}
          </Color>
        </small>
      </Paragraph>
    </div>
  )

  const chipContent = () => onClick
    ? (
      <InvisiButton
        hasHoverEffect
        hasPadding={false}
        isDisabled={isDisabled}
        onClick={onClick}
      >
        {renderContent()}
      </InvisiButton>
    )
    : renderContent()

  return hasTooltip
    ? (
      <Tooltip
        backgroundVariance='white'
        key={key}
        label={label}
      >
        {chipContent()}
      </Tooltip>
    )
    : chipContent()
}

export default ParameterChip
